import DefaultModal from '../layouts/modal/LayoutModal'

export const DEFAULT_MODAL_LAYOUT_DEPRECATED = 'DefaultModal'

export const MODAL_LAYOUT_COMPONENTS = {
  DefaultModal,
}
